'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
interface TossExitConfirmModalProps {
  opened: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
}
export const TossExitConfirmModal = t0 => {
  const $ = _c(11);
  const {
    opened,
    onClose,
    onConfirm
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = <Button theme="sub-line" onClick={onClose}>취소</Button>;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onConfirm) {
    t2 = <Button onClick={onConfirm}>이동</Button>;
    $[2] = onConfirm;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClose || $[8] !== opened || $[9] !== t3) {
    t4 = <Modal opened={opened} onClose={onClose} header={"\uD1A0\uC2A4\uB85C \uC774\uB3D9"} description={"\uD1A0\uC2A4 \uC571\uC73C\uB85C \uC774\uB3D9\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"} buttonFooter={t3} />;
    $[7] = onClose;
    $[8] = opened;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};